var map = {
	"./4corecopperwire.jpg": 7497,
	"./CopperWire.jpg": 352,
	"./Director1.jpg": 5938,
	"./Director2.jpg": 5104,
	"./Northflex_logo.jpg": 2770,
	"./SilverWire.jpg": 6035,
	"./aboutus.jpg": 2312,
	"./cpvcpipes.jpg": 6844,
	"./dishcable.jpg": 840,
	"./dishcable1.jpg": 1107,
	"./factory1.jpg": 9620,
	"./factory2.jpg": 6353,
	"./housewire.jpg": 7922,
	"./img6.jpg": 571,
	"./industrialwires.jpg": 2213,
	"./pump pic.jpg": 8080,
	"./pvcinsulatedtwincable.jpg": 7407,
	"./submersiblecable.jpg": 9645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2120;